import React from 'react';
import { t } from 'i18next';
import { FiChevronDown, FiMoreHorizontal } from 'react-icons/fi';
import { Dropdown } from '@/components/custom/dropdown/dropdown';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import moment from 'moment';
import { useState } from 'react';
import { useAuditorium } from '@/hooks/useAuditorium';
import { confirm } from '@/lib/confirm';
import { ChatFile, ChatFileContent, ChatFileMeta, ChatFileTitle } from '@/components/custom/chat';
import { Button } from '@/components/ui/button';
import { PlayfulCardButton } from '@/components/custom/playful-card';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';

export function AuditoriumViewCardFile(props) {
  const { messages, files, deleteFile } = useAuditorium();
  const { file, id } = props;
  const isAdmin = !useCheckIncludeProfiles({ only: ['student'] });
  const playfulStudent = usePlayfulStudent();
  const playfulTeacher = usePlayfulTeacher();
  const isPlayful = playfulStudent || playfulTeacher;
  const [showContent, setShowContent] = useState(false);

  const handleView = () => {
    setShowContent(true);
    window.open(file.file.url, '_blank');
  };

  const handleDelete = async () => {
    const confirmed = await confirm({
      title: 'Deseja mesmo excluir este arquivo?',
      description: 'Esta ação não poderá ser desfeita',
      confirmText: 'Sim',
      cancelText: 'Não'
    });
    if (confirmed) {
      deleteFile(id, file);
    }
  };

  return (
    <ChatFile className={isPlayful ? 'rounded-2xl border-neutral-lightest shadow-card transition-shadow duration-150 hover:shadow-md' : undefined}>
      <ChatFileContent>
        <ChatFileTitle>{file.filename}</ChatFileTitle>
        <ChatFileMeta>{`${file.user?.name ?? ''} em ${moment(file?.['created-at']).format('HH:mm')}`}</ChatFileMeta>
      </ChatFileContent>

      {isAdmin ? (
        isPlayful ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <PlayfulCardButton
                variant="outline"
                aria-label={t('button.options')}
                className="h-9 w-9 flex-none gap-0 px-0"
              >
                <FiChevronDown size={20} />
              </PlayfulCardButton>
            </DropdownMenuTrigger>

            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={handleView}>{'Visualizar'}</DropdownMenuItem>
              <DropdownMenuItem onClick={handleDelete}>{'Excluir'}</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : (
          <Dropdown>
            <Dropdown.Toggle>
              <span className="card__icon-wrapper">
                <FiMoreHorizontal className="card__icon" />
              </span>
            </Dropdown.Toggle>

            <Dropdown.Content>
              <Dropdown.Item onClick={handleView}>{'Visualizar'}</Dropdown.Item>
              <Dropdown.Item onClick={handleDelete}>{'Excluir'}</Dropdown.Item>
            </Dropdown.Content>
          </Dropdown>
        )
      ) : isPlayful ? (
        <PlayfulCardButton
          className="w-auto shrink-0 px-5 py-2 text-xs"
          onClick={() => window.open(file.file.url, '_blank', 'noopener,noreferrer')}
        >
          Baixar
        </PlayfulCardButton>
      ) : (
        <Button
          variant="outline"
          size="sm"
          asChild
        >
          <a
            href={file.file.url}
            target="_blank"
            download
            rel="noopener noreferrer"
          >
            Baixar
          </a>
        </Button>
      )}
    </ChatFile>
  );
}
